<template>
  <div class="top-menu">
    <div class="top-menu-center">
      <a href="/">
        <img class="main-logo" src="../../assets/img2/pc/fzg-logo.png"/>
      </a>
      <div class="fzg-menu">
        <div class="menu-item" :class="{'menu-item-active': isMenuActive('/')}"> <a href="/">首页</a></div>
        <div class="menu-item" :class="{'menu-item-active': isMenuActive('/about')}"> <a href="/about">关于我们</a></div>
        <div class="menu-item" :class="{'menu-item-active': isMenuActive('/service')}"> <a href="/service">小饭桌创服</a></div>
        <div class="menu-item" :class="{'menu-item-active': isMenuActive('/investment')}"> <a href="/investment">小饭桌创投</a></div>
        <div class="menu-item" :class="{'menu-item-active': isMenuActive('/fa')}"> <a href="/fa">凡卓资本</a></div>
        <div class="menu-item" :class="{'menu-item-active': isMenuActive('/news')}"> <a href="/news">动态新闻</a></div>
        <div class="menu-item" :class="{'menu-item-active': isMenuActive('/join')}"> <a href="/join"> 加入我们</a></div>
        <a class="menu-item menu-media" href="https://www.xfz.cn/" target="blank">小饭桌媒体门户</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    isMenuActive(path) {
      return this.$route.path == path
    }
  }
}

</script>

<style lang="scss" scoped>
  .top-menu {
    // background: #ccc;
    display: flex;
    height: 80px;
    .top-menu-center {
      // border: 1px solid red;
      margin: 20px auto 0;
      width: 1100px;
      .main-logo {
        // border: 1px solid red;
        width: 160px;
        margin-right: 10px;
        margin-left: 0px;
        // margin-top: 10px;
        object-fit: contain;
        display: inline-block;
      }
      .fzg-menu {
        // border: 1px solid red;
        // background: #bbb;
        width: 920px;
        vertical-align: top;
        display: inline-block;
        margin: 5px auto 0;
        text-align: right;
        .menu-item {
          // border: 1px solid gray;
          // min-width: 105px;
          color: white;
          cursor: pointer;
          font-size: 16px;
          margin-left: 25px;
          padding: 5px 5px;
          text-align: center;
          display: inline-block;
          a {
            color: white;
          }
          &:hover, &.active {
            color: #ce262f;
          }
        }
        .menu-item-active {
          a {
            color: #ce262f;
          }
        }
        .menu-media {
          border: 1px solid #ce262f;
          color: #ce262f;
          width: 140px;
          padding: 4px 6px;
          border-radius: 15px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// FzgMenu.vue?7e55ba3d